module.exports = __webpack_public_path__ + "static/media/_scan_success.912d343c.png";